import { EntityTypes } from '@/constants/entityTypes'
import { Permissions } from '@/constants/permissionEnums'
import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const priceAlertRoutes = [
  {
    path: 'price-alerts',
    name: 'PriceAlert',
    component: () => import('@/views/PriceAlert/PriceAlert.vue'),
    meta: {
      title: `${t('price_alert', 2)} | Pour Now`,
      mainRouteName: 'PriceAlert',
      permissionIdentifiers: [Permissions.CAN_VIEW_PRICE_ALERT],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
]
